// extracted by mini-css-extract-plugin
module.exports = {"skuInfo":"_6UDhsh7OLfAdbPDrWJaikQ==","skuInfoBullets":"skd6mxUty1d34szmDHzJeQ=="};